<script lang="ts">
  import { Col, FormGroup, Label } from "sveltestrap";
  import { Brandstate, Checkboxstates, Successstate, primarystate } from "../../../../utils/Constant/Constant";
</script>
<Col sm="12">
  <h5>{Checkboxstates}</h5>
</Col>
<Col>
  <FormGroup class="m-t-15">
    <div class="checkbox checkbox-primary">
      <input id="checkbox-primary-1" type="checkbox">
      <Label for="checkbox-primary-1">{Successstate}</Label>
    </div>
    <div class="checkbox checkbox-secondary">
      <input id="checkbox-dark" type="checkbox" disabled>
      <Label for="checkbox-dark">{Brandstate}</Label>
    </div>
    <div class="checkbox checkbox-success">
      <input id="checkbox-primary" type="checkbox">
      <Label for="checkbox-primary">{primarystate}</Label>
    </div>
  </FormGroup>
</Col>